export default __webpack_public_path__ + "static/media/Background_00209.65050d8b.png";